import { render, staticRenderFns } from "./ShippingAdd.vue?vue&type=template&id=681eed78&scoped=true"
import script from "./ShippingAdd.vue?vue&type=script&lang=js"
export * from "./ShippingAdd.vue?vue&type=script&lang=js"
import style0 from "./ShippingAdd.vue?vue&type=style&index=0&id=681eed78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681eed78",
  null
  
)

export default component.exports